import { ChevronDown, Download } from "lucide-react";
import type { ExportActionLabelProps } from "./types";

export const ExportActionLabel = ({
  label,
  hasMenu,
}: ExportActionLabelProps) => (
  <span className="flex items-center gap-1 text-blue-600 hover:text-blue-700 hover:underline transition-colors">
    <Download size={12} />
    <span>{label}</span>
    {hasMenu && <ChevronDown size={12} />}
  </span>
);
